module.exports = __webpack_public_path__ + "dimer/static/img/t$eImg1.e0b918f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t$eImg1.jpg
// module id = 8kcp
// module chunks = 0